import { AsperaService, AsperaBanner } from '../aspera/aspera.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { UsersService } from '../users/users.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, OnDestroy {

  saveAction: any;
  saveEnabled: boolean = false;
  navigationAction: any;
  navigationEnabled: boolean = false;
  footerEnabled: boolean = false;
  headerHidden: boolean = false;
  banner$: Observable<AsperaBanner> = this.asperaService.banner$;

  migrationBannerVisible: boolean = false;
  bannerPhaseClass: string = 'phase-info';
  bannerMessage: string = '';
  bannerLearnLink: string = 'Learn more';

  private profileSubscription: Subscription;
  private userClientMode: string = 'connect';
  private currentPhase: number = 1;
  // UPDATE THIS DATE when TRANSP-6206 (Timeline) is finalized
  private readonly CUTOVER_DATE = new Date('2027-03-01');
  private readonly PHASE_2_DAYS_BEFORE = 60;
  private readonly PHASE_3_DAYS_BEFORE = 14;

  constructor(private usersService: UsersService, private asperaService: AsperaService) { }

  ngOnInit() {
    this.profileSubscription = this.usersService.profile$.subscribe((profile) => {
      if (profile) {
        this.userClientMode = profile.asperaClientMode || 'connect';
        this.updateBannerState();
      }
    });
  }
  onBannerLink(banner: AsperaBanner) {
    if (banner.action != null) { banner.action(); }
  }

  onActivate(component) {
    if (component.canSave != null) {
      component.canSave.subscribe((event: {enabled: boolean, action?: any}) => {
        this.saveEnabled = event.enabled;
        this.saveAction = event.action;
      })
    }
    if (component.canNavigate != null) {
      component.canNavigate.subscribe((event: {enabled: boolean, action?: any}) => {
        this.navigationEnabled = event.enabled;
        this.navigationAction = event.action;
      })
    }
    if (component.hasFooter == true) {
      this.footerEnabled = true;
    }
    if (component.headerHiddenChanged != null) {
      component.headerHiddenChanged.subscribe((event: {hidden: boolean}) => {
        this.headerHidden = event.hidden;
      })
    }
  }

  onDeactivate(component) {
    this.saveEnabled = false;
    this.saveAction = null;
    this.navigationEnabled = false;
    this.navigationAction = null;
    this.footerEnabled = false;
    this.headerHidden = false;
  }

  ngOnDestroy() {
    if (this.profileSubscription) {
      this.profileSubscription.unsubscribe();
    }
  }

  // --- Migration banner logic ---
  updateBannerState() {
    const now = new Date();
    const daysUntilCutover = Math.ceil(
      (this.CUTOVER_DATE.getTime() - now.getTime()) / 86400000
    );

    if (daysUntilCutover <= this.PHASE_3_DAYS_BEFORE) { this.currentPhase = 3; }
    else if (daysUntilCutover <= this.PHASE_2_DAYS_BEFORE) { this.currentPhase = 2; }
    else { this.currentPhase = 1; }

    switch (this.currentPhase) {
      case 3: this.bannerPhaseClass = 'phase-urgent'; break;
      case 2: this.bannerPhaseClass = 'phase-warning'; break;
      default: this.bannerPhaseClass = 'phase-info'; break;
    }

    switch (this.currentPhase) {
      case 3:
        this.bannerMessage = 'Aspera Connect support ends in ' + daysUntilCutover +
          ' days. Switch to Aspera Desktop to avoid interruption.';
        break;
      case 2:
        this.bannerMessage = 'Aspera Connect will stop working on ' +
          this.CUTOVER_DATE.toLocaleDateString('en-US', {month: 'long', day: 'numeric', year: 'numeric'}) +
          '. Please switch to Aspera Desktop.';
        break;
      default:
        this.bannerMessage = 'Aspera Connect is being retired. MM3 now supports Aspera Desktop.';
        break;
    }

    this.bannerLearnLink = this.currentPhase === 1 ? 'Learn more' : 'How to switch';

    const dismissedPhase = parseInt(localStorage.getItem('bannerDismissedPhase') || '0', 10) || 0;
    this.migrationBannerVisible = this.userClientMode !== 'desktop'
      && now <= this.CUTOVER_DATE
      && this.currentPhase > dismissedPhase;
  }

  dismissBanner() {
    localStorage.setItem('bannerDismissedPhase', '' + (this.currentPhase || 1));
    this.migrationBannerVisible = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/layout.component.ts